export const themes = {

    colorCodes: {
        black: 'black',
        electricBlue: '#1D40DC',
        red: '#F41515',
        lightPurple: '#9246e0',
        lightGrey: '#adacb0',


    },
    fontFamilies: {
        accentFont: '"Permanent Marker", serif',
        generalFont: '"Montserrat", sans-serif'
    }
}

